



















import Vue from 'vue'
import {OperationBar} from '@corets/type'
import utils from '@corets/utils'
import dict from '@custom/dict'

export default Vue.extend({
    name: 'NCommonOperationBar',
    props: {
        operationObj: {
            type: Object as () => OperationBar
        }
    },
    data () {
        return {
            dict,
            isShrink: false
        }
    },
    methods: {
        shrinkContent () {
            const self = this as any
            self.isShrink = !self.isShrink
            utils.fullScreenCtl(self.isShrink)
            self.$emit('fullscreen', self.isShrink)
        },
        triggerBtn (method: any) {
            const self = this as any
            self.$emit('btnevent', method)
        }
    }
})
